import { ReactNode, useRef } from "react";
import { MemeEditorProviderContext } from "./MemeEditorContext";
import { MemeGeneratorProps } from "./MemeGenerator";

interface MemeEditorProviderProps extends MemeGeneratorProps {
    children: ReactNode;
}
export const MemeEditorProvider = ({ initialMemes, defaultMeme, children, isEditPage }: MemeEditorProviderProps) => {
    const canvasContainerRef = useRef<HTMLDivElement>(null);
    const itemsContainerRef = useRef<HTMLDivElement>(null);
    const shadowParentContainerRef = useRef<HTMLDivElement>(null);
    const shadowItemsContainerRef = useRef<HTMLDivElement>(null);

    return (
        <MemeEditorProviderContext.Provider
            value={{
                canvasContainerRef,
                itemsContainerRef,
                shadowItemsContainerRef,
                shadowParentContainerRef,
                initialMemes,
                defaultMeme,
                isEditPage,
            }}
        >
            {children}
        </MemeEditorProviderContext.Provider>
    );
};
